<div class="poi-card">
  <div class="row poi-card-top">
    <div class="column poi-card-left">
      <img src="/assets/images/american-family-insurance-logo.png" class="sideways-logo" />
    </div>
    <div class="column fill poi-card-right">
      <div class="poi-card-header"><h1 class="poi-card-title">Illinois Insurance Card</h1></div>
      <div class="poi-card-content">
        <div class="poi-card-content-block">DONALD KELLY</div>
        <div class="poi-card-content-block">
          <div>Policy Number: {{ policy.policyNumber }}</div>
          <div class="poi-card-content-block-left">
            Effective Date: {{ policy.periodStartDate }}
          </div>
          <div class="poi-card-content-block-right">
            Expiration Date: {{ policy.periodEndDate }}
          </div>
        </div>
        <div class="poi-card-content-block">
          <div>
            Vehicle Description<br />{{ vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model }}
          </div>
          <div>Vehicle Identification Number:<br />{{ vehicle.vinSerialNumber }}</div>
        </div>
        <div class="poi-card-content-block">
          <div>Coverages: {{ policy.policyCoverages }}</div>
        </div>
        <div class="poi-card-content-block">
          <div class="poi-card-content-block-left">
            <div>Agent: David Pierce Agency, LLC</div>
            <div>Agent Phone: 1-608-664-9494</div>
          </div>
          <div class="poi-card-content-block-right">
            <div>Producer ID:</div>
            <div>20872</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row fixed-bottom">
    <span
      >The information on this card is provided to you as a courtesy and may not be accepted as a
      valid proof of insurance in your state.</span
    >
  </div>
</div>
